import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonPercentage = function ButtonPercentage(_ref) {
  var label = _ref.label,
    onSkip = _ref.onSkip,
    sizePercentage = _ref.sizePercentage,
    autoplayNext = _ref.autoplayNext;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    onClick: onSkip,
    className: "tw-w-[50%] tw-h-full tw-relative tw-rounded-1 tw-btn tw-font-link2 tw-bg-primary-dark-600  tw-text-neutral-light-100 ",
    children: [autoplayNext ? /*#__PURE__*/_jsx("span", {
      className: " tw-h-full tw-rounded-1 tw-bg-primary-light-600 tw-absolute",
      style: {
        width: sizePercentage
      }
    }) : null, /*#__PURE__*/_jsx("span", {
      className: "tw-py-0.8 tw-flex tw-items-center tw-justify-center tw-h-full tw-z-1 tw-w-full",
      children: label
    })]
  });
};
export default ButtonPercentage;